import type { TSerializedWidget } from 'src/entities/workspace/types';
import { DrillingMultiAnalysisWidgetEntity } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';
import { parseDrillingMultiAnalysisWidgetInternalState } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/parseDrillingMultiAnalysisWidget';
import type { TWidgetMapperOptions } from 'src/serializers/WidgetSerializerService';

export function mapDrillingMultiAnalysisWidget(
  widget: TSerializedWidget,
  index: number,
  options?: TWidgetMapperOptions,
): DrillingMultiAnalysisWidgetEntity {
  const internalState = parseDrillingMultiAnalysisWidgetInternalState(widget.internalState ?? {});

  const drillingMultiAnalysisWidget = new DrillingMultiAnalysisWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'drilling-multi-analysis-widget',
    },
    {
      uuid: widget.uuid,
      isPinned: !!widget.isPinned,
      zIndex: index + 1,
      isFullscreen: widget.isFullscreen ?? false,
      position: {
        x: widget?.position?.x ?? 0,
        y: widget?.position?.y ?? 0,
      },
      size: {
        w: widget.size?.w ?? 150,
        h: widget.size?.h ?? 80,
      },
      groupId: widget.groupId,
      isGroupsDefaultOpened: false,
    },
    options?.wellListPanelStore ?? null,
  );

  return drillingMultiAnalysisWidget;
}
